export function formatTimeToCustomVersion(dateTimeString: any, isSortDate: boolean) {
	const months = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];

	const date = new Date(dateTimeString);
	const month = months[date.getMonth()];
	const day = String(date.getDate()).padStart(2, "0");
	const year = date.getFullYear();
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");
	const offsetHours = Math.floor(date.getTimezoneOffset() / 60);
	const offsetSign = offsetHours < 0 ? "+" : "-";
	const offsetFormatted = `${offsetSign}${String(Math.abs(offsetHours)).padStart(1)}`;

	if (isSortDate) {
		return `${month} ${day}`;
	}

	return `${month} ${day}, ${year} ${hours}:${minutes} GMT ${offsetFormatted}`;
}
